import { Component, OnDestroy,ViewChild,OnInit,Input, Output, EventEmitter } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { first, map, takeUntil,share } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';
import { filter } from 'rxjs/operators';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Validations } from '../../../../utility/validators';
import { PasswordStrengthValidator } from '../../../../utility/password-strength.validators';
import { NotificationService } from '../../../main/shared/notification.service';
// import { UsermasterService } from '../../../main/masters/usermaster/usermaster.service';
import { DatabindingService } from 'app/services/databinding.service';
import { Router } from '@angular/router';
import {AutoCompleteComponent } from '@progress/kendo-angular-dropdowns';
import { DatePipe, formatDate } from '@angular/common';
import { Subscription, timer } from "rxjs";
import { HeaderService } from './header.service';
import { DataChangeNotificationService } from '@progress/kendo-angular-treeview';
// import { MessagingService } from '../../shared/messaging.service';
import { commonmodel } from 'app/main/shared/commonmodel';
import { Common } from 'utility/common';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
  [x: string]: any;

  message;
  @ViewChild("autocompletePage", { static: false }) autocompletePage: AutoCompleteComponent;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  password: string;
  confirmpassword: string;
  public base64Img: any;
  public data = [];
  public source;
  public standardDateOnlyFormat: any = this.databindingService.GetStandardDateOnlyFormat(); 
  public standardDateFormat: any = this.databindingService.GetStandardDateFormat();  
  //public clientid: any= this.databindingService.GetClientId();
  //public systemid: any= this.databindingService.GetSystemId();
  //public userid: any= this.databindingService.GetUserId();

  
  time = new Date();
  rxTime = new Date();
  intervalId;
  subscription: Subscription;
  //@Output() cancel: EventEmitter<any> = new EventEmitter();

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Analytics',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },

  ];

  currentTheme = 'dark';

  userMenu = [
    //{ title: 'Profile' }, 
    { title: 'Log out' },
    // { title: 'Themes' },
     //{ title: 'Change Password' }
  ];


  
  public interval;
  public interval2;
  public isBlink = false;
  public opened = false;
  isChangePassword = false;

  public close(status) {
    this.opened = false;
    //this.cancel.emit();
  }  

  public open() {    
    this.opened = true;
  }

  public closeChangePassword(status) {
    this.password = '';
    this.isChangePassword = false;
    this.editChangePasswordForm.reset();
  }

  public openChangePassword() {
    
    this.editChangePasswordForm.reset();
    this.isChangePassword = true;
  }

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private headerService : HeaderService,
    private themeService: NbThemeService,
    //private userService: UsermasterService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authenticationService: AuthenticationService,
    private databindingService: DatabindingService,
    private router: Router,
    private notifyService: NotificationService,
    private datePipe: DatePipe,
    //private messagingService: MessagingService 
    ) {
  }

  public listItems: Array<string> = ['Light', 'Dark'];
  public selectedValue = 'Light';

  //public listItems2: Array<string> = ['Routereplay', 'Livevehicle', 'RunningTrips'];
  //public selectedValue2 = 'Routereplay';
  public selectedmenu = null; 
  public MenuList: any[] = [];
  public editChangePasswordForm: FormGroup = new FormGroup({
    id: new FormControl(),
    password: new FormControl('', Validators.compose([Validators.required, Validators.minLength(8), PasswordStrengthValidator])),
    confirmpassword: new FormControl('', Validators.required)
  });

   //=======DASHBOARD WATCH FUNCTIONALITY
   today= new Date();
   jstoday = '';
   //=======DASHBOARD WATCH FUNCTIONALITY

  ngOnInit() {
    //=======DASHBOARD WATCH FUNCTIONALITY
    //this.GetMenuListByLoginUser();
    //this.GetSelectedLandingPage();

  
    // setInterval(() => {
    //   //this.now = new Date();
      this.today= new Date();
      this.jstoday = formatDate(this.today, 'dd-MM-yyyy HH:mm:ss', 'en-US', '+0530');
    // }, 1000);
    //=======DASHBOARD WATCH FUNCTIONALITY
    this.currentTheme = this.themeService.currentTheme;
    //this.getMenus();
      // Using Basic Interval
      // this.intervalId = setInterval(() => {
      //   this.time = new Date();
      // }, 1000);
  
      
      
    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((users: any) => this.user = users.nick);
    this.user = this.authenticationService.currentUserValue.userName;
    if(this.user == 'AfcsAdmin')
    {
      this.userMenu = [
        { title: 'Log out' },
        { title: 'Themes' },
        //{ title: 'Change Password' } //Super Amdin cannot change password
      ];
    }

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick().subscribe((event) => {
      
      if (event.item.title === 'Log out') {
        this.authenticationService.logout();
      }
    })

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => title == 'Themes' ? this.open() : 0);

    this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'my-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => title == 'Change Password' ? this.openChangePassword() : 0);

      // this.databindingService.GetClientHeaderLogoUrl().pipe(first()).subscribe(result => {
        
      //   this.base64Img = result;
      // });

    //this.GetIncidentDataNotificationAlertPanel();
    }
    // Start - Firebase Push Notification Added by Bhavesh Savaliya On 17-Feb-2021
    //this.messagingService.requestPermission(this.clientid, this.userid, '')
    //this.messagingService.receiveMessage()
    //this.message = this.messagingService.currentMessage

  //   this.messagingService.customObservable.subscribe((data) => {
  //     if (!this.CheckNullOrUndefined(data)) {
  //       //if (this.openedprimarykeyid != data.PrimaryKeyId && data.PrimaryKeyId != null && !this.CheckNullOrUndefined(data)) {
  //       this.isDetailPush = false;
  //       this.btnText = 'Detail';
  //       //this.infodata = [];
        
  //       // if (data.IsAudioAlert == 'true' || data.IsAudioAlert == true || data.IsAudioAlert == '1' || data.IsAudioAlert == 1)
  //       // {          
  //       //   let audio: HTMLAudioElement = new Audio(`${environment.apiUrl}/VehicleDocs/push_notification_alert.mp3`);
  //       //   audio.play();
  //       // }

  //       this.OpenPushNotification(data);

  //       if (this.interval2) {
  //         clearInterval(this.interval2);
  //       }
  //       this.isBlink = true;
  //       this.interval2 = setInterval(() => {
  //         this.isBlink = false;
  //       }, 3000);
        
  //       if (this.interval) {
  //         clearInterval(this.interval);
  //       }
  //       this.interval = setInterval(() => {          
  //         // this.openedprimarykeyid = 0;
  //         // this.openedincid = 0;
  //         // this.infodata = []; 

  //         this.openedchkid = 0;
  //       }, 10000);

  //       this.GetIncidentDataNotificationAlertPanel();
  //     }
  //   });

  //   //// End - Firebase Push Notification Added by Bhavesh Savaliya On 17-Feb-2021
  // }

//   CheckNullOrUndefined(value) {
//     return typeof value === "undefined" || value == '' || value == null
//   }

//   GetMenuListByLoginUser(){
//     this.databindingService.GetAllMenusByLoginUser(this.systemid).pipe(first()).subscribe(result => {
//       this.MenuList = JSON.parse(result.Data);
//     });
//  }
//  GetSelectedLandingPage(){
//   this.databindingService.GetSelectedlandingpage(this.systemid,this.userid).pipe(first()).subscribe(result => {
//   this.selectedmenu = JSON.parse(result.Data)[0].menuid
//   });
// }

//  ValueChangeMenu(e: any)
//  {
//    this.selectedmenu = e;
//  }

//   passwordStrengthCheck(value:any)
//   {
//     let upperCaseCharacters = /[A-Z]+/g;
//     let lowerCaseCharacters = /[a-z]+/g;
//     let numberCharacters = /[0-9]+/g;
//     let specialCharacters = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

//     if (upperCaseCharacters.test(value) === false || lowerCaseCharacters.test(value) === false || numberCharacters.test(value) === false || specialCharacters.test(value) === false) 
//     {
//       return false;
//     }
//     else
//     {
//       return true;
//     }
//   }

updatePassword() {
  if (this.password == this.confirmpassword) {
    //  Common.showloader();
    this.editChangePasswordForm.value.id = this.authenticationService.currentUserValue.idamUserId;
    let reqPara: any = {};
    reqPara.id=this.editChangePasswordForm.value.id;
    reqPara.password=this.editChangePasswordForm.value.password;
    reqPara.access_Token = this.authenticationService.currentUserValue.token;
    this.authenticationService
      .UpdatePassword(reqPara)
      .pipe()
      .subscribe(
        res => {
          if(res.IsSuccess)
          {
            this.notifyService.showSuccess('Password Changed SuccessFully','Success')
            //  Common.hideloader();

          }
        },
      );
      this.notifyService.showSuccess('Password Changed SuccessFully','Success')

      this.closeChangePassword(true);
  }
  else {
    this.notifyService.showWarning('Passwords do not match', 'Warning')
  }
}

//   Save()
//   {
//     if(this.selectedmenu != null)
//     {
//       var data =
//       {
//         menuid : this.selectedmenu,
//         systemid : this.systemid,
//         userid : this.userid,
//         clientid : this.clientid
//       };
//       this.headerService
//         .Save(data)
//         .pipe()
//         .subscribe(
//           res => {
//             if(res.IsSuccess)
//             {
//               this.opened = false;
//             }
//           },
//         );
//     }
//     else
//     {
//       this.notifyService.showWarning('Please select landing page', 'Warning');
//     }
//   }

//   ngOnDestroy() {
//     this.destroy$.next();
//     this.destroy$.complete();
//     clearInterval(this.intervalId);
//     if (this.subscription) {
//       this.subscription.unsubscribe();
//     }

//     if (this.interval) {
//       clearInterval(this.interval);
//     }

//     if (this.interval2) {
//       clearInterval(this.interval2);
//     }
//   }

//   changeTheme(themeName: string) {
//     this.themeService.changeTheme(themeName);
//   }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

//   navigateHome() {
//     this.menuService.navigateHome();
//     return false;
//   }

  NavigateTo(value) {
    let data=this.data.filter(x=>x.text.toLowerCase()===value.toLocaleLowerCase());
    if(data.length==1)
    this.router.navigate([data[0].value]);
    this.autocompletePage.text="";
  }
  handleFilter(value) {
    this.source = this.data.filter(x=>x.text.toLowerCase().indexOf(value.toLowerCase())!== -1);
  }
  getMenus() {
    
    if (this.authenticationService.currentUserValue) {
      const user = this.authenticationService.currentUserValue;
      if (user.userMenu.length > 0) {
        for (let i = 0; i < user.userMenu.length; i++) {
          let res = this.iteratechild(user.userMenu[i])
          if (res.length > 0)
            this.data = this.data.concat(res);
        }
      }
    }
  }

  iteratechild(item) {
    let menu = [];
    if (item.children && item.children.length > 0) {
      for (let i = 0; i < item.children.length; i++) {
        let res = this.iteratechild(item.children[i]);
        if (res.length > 0)
          menu = menu.concat(res);
      }
    }
    else {
      menu.push({ text: item.title, value: item.link })
    }
    return menu;
  }

  ///// Start - Alert And Notification Panel 
  public isAlertPanelShow = false;
  public isSortData = false;
  public isShowLoadMore = false;
  public fetchData=[];
  public ALertPanelNotificationData: any;
  public notificationCount: number = 0;
  public notificationDisplayCount: number = 10;

  ShowNotificationPanel() {
    this.isAlertPanelShow = !this.isAlertPanelShow;    
  }

  // DismissNotificationFromAlertPanel(data: any, arrIndex: number){  
  //   var param;
  //   if (this.CheckNullOrUndefined(data)) {
  //     param = {
  //       chk: 1,
  //       dismissby: this.userid,
  //       clientId: this.clientid
  //     };
  //   }
  //   else {
  //     param = {
  //       chk: 0,
  //       chkid: data.chkid,
  //       transferid: data.transferid,        
  //       dismissby: this.userid,
  //       clientId: this.clientid
  //     };
  //   }

  //   this.headerService.DismissIncident(param)
  //     .pipe(first())
  //     .subscribe(result => {
  //       if (result.IsSuccess) {
  //         //this.notifyService.showWarning(result.Message, 'Success');
  //         if (this.CheckNullOrUndefined(data)) {
  //           this.ALertPanelNotificationData = null;
  //           this.notificationCount = 0;
  //         }
  //         else {
  //           this.ALertPanelNotificationData.splice(arrIndex, 1);
  //           this.notificationCount = this.ALertPanelNotificationData.length;
  //           this.isShowLoadMore = this.ALertPanelNotificationData.length == 0 || this.ALertPanelNotificationData.length <= 10 ? false : true;
  //         }
  //       }
  //       else
  //       {
  //         this.notifyService.showWarning(result.Message, 'Warning');
  //       }
  //   });
  // }

  SortNotificationData(){
    
    this.isSortData = !this.isSortData;
    if (this.isSortData == false) { /// this.isSortData == false For Desc Sort Order
      this.ALertPanelNotificationData.sort((a, b) => 0 - (a.incidenttime < b.incidenttime ? -1 : 1));      
    }    
    
    if (this.isSortData == true) { /// this.isSortData == true For Asc Sort Order 
      this.ALertPanelNotificationData.sort((a, b) => 0 - (a.incidenttime > b.incidenttime ? -1 : 1));      
    }
  }

  // GetIncidentDataNotificationAlertPanel(){        
  //   var data = {      
  //     clientId: this.clientid,
  //     userId: this.userid
  //   };

  //   var self = this
  //   this.headerService.GetIncidentDataNotificationAlertPanel(data)
  //   .pipe(first())
  //   .subscribe(result => {   
  //     if (result.Data != null) { 
  //       this.fetchData = JSON.parse(result.Data);
  //       this.fetchData.filter(function (element, index) {
  //         element["fromdate"] = element["fromdate"] == null ? "N/A" : self.datePipe.transform(element["fromdate"], self.standardDateOnlyFormat);
  //         element["todate"] = element["todate"] == null ? "N/A" : self.datePipe.transform(element["todate"], self.standardDateOnlyFormat);
  //         element["requesteddate"] = element["requesteddate"] == null ? "N/A" : self.datePipe.transform(element["requesteddate"], self.standardDateFormat);
  //       });
  //       this.ALertPanelNotificationData = this.fetchData;
  //       this.notificationCount = this.ALertPanelNotificationData.length;        
  //       this.isShowLoadMore = this.ALertPanelNotificationData.length == 0 || this.ALertPanelNotificationData.length <= 10 ? false : true;
  //     }
  //     else
  //     {
  //       this.notifyService.showWarning(result.Message, 'Warning');
  //     }
  //   });
  // }

  DetailNotificationFromAlertPanel (i) {  
    if (this.interval) {
      clearInterval(this.interval);
    }

    this.openedchkid = i.chkid;
    this.openedrequestname = i.requestname;
    this.openedtransferid = i.transferid;
    this.openedvehicleregno = i.vehicleregno;
    this.openedstaffname = i.staffname;
    this.openedtransfertypename = i.transfertypename;
    this.openeddepotname = i.depotname;
    this.openeddepartmentname = i.departmentname;
    this.openedfromdate = i.fromdate;
    this.openedtodate = i.todate;
    this.openedrequesteddate = i.requesteddate;
    
    // this.openedprimarykeyid = i.primarykeyid;
    // this.openedincid = i.incidentid;
    // this.openedincname = i.incident_name;    
    // this.openedincstatus = Number(i.incident_status)
    // this.openedincgeneratetime = i.incidenttime;
    // this.openedinclastescalateime = i.escalatetime;
        
    this.isDetailPush = false;
    this.isAlertPanelShow = false;
    this.DetailNotification();
  }

  LoadMore() {    
    if (this.notificationCount > this.notificationDisplayCount) {
      this.notificationDisplayCount += 10;
    } else {
      this.isShowLoadMore = false;
    }
  }

  ///// End - Alert And Notification Panel 

  ///// Start - Push Notification Dialog 
  //public infodata: any;
  public griddata=[]; 
  public organizationlevel=[];
  
  public fromDatetime: Date = new Date();  
  public isDetailPush = false;
  public btnText = 'Detail';

  // public openedprimarykeyid: number = 0;
  // public openedincid: number = 0;
  // public openedincname: string = '';
  // public openedincstatus: number = 0;
  // public openedincgeneratetime: string = '';
  // public openedinclastescalateime: string = '';
  // public openincdatetime: string = '';

  
  public openedchkid: number = 0;
  public openedrequestname: string = '';
  public openedtransferid: number = 0;
  public openedvehicleregno: string = '';
  public openedstaffname: string = '';
  public openedtransfertypename: string = '';
  public openeddepotname: string = '';
  public openeddepartmentname: string = '';
  public openedfromdate: string = '';
  public openedtodate: string = '';
  public openedrequesteddate: string = '';

  OpenPushNotification(data: any) {
    this.openedchkid = data.chkid;
    this.openedrequestname = data.requestname;
    this.openedtransferid = data.transferid;
    this.openedvehicleregno = data.vehicleregno;
    this.openedstaffname = data.staffname;
    this.openedtransfertypename = data.transfertypename;
    this.openeddepotname = data.depotname;
    this.openeddepartmentname = data.departmentname;
    this.openedfromdate = data.fromdate == null ? "N/A" : this.datePipe.transform(data.fromdate, this.standardDateOnlyFormat);
    this.openedtodate = data.todate == null ? "N/A" : this.datePipe.transform(data.todate, this.standardDateOnlyFormat);
    this.openedrequesteddate = data.requesteddate == null ? "N/A" : this.datePipe.transform(data.requesteddate, this.standardDateFormat);

    // this.openedprimarykeyid = Number(data.PrimaryKeyId);
    // this.openedincid = Number(data.IncidentId);
    // this.openedincname = data.IncidentName;
    // //this.openedincstatus = data.IncidentStatus == null ? 0 : data.IncidentStatus;
    // this.openedincstatus = Number(data.IncidentStatus)
    // this.openedincgeneratetime = data.IncidentDate == null ? "N/A" : this.datePipe.transform(data.IncidentDate, this.standardDateFormat);
    // this.openedinclastescalateime = data.EscalateTime == null ? "N/A" : this.datePipe.transform(data.EscalateTime, this.standardDateFormat);
    // this.openincdatetime = this.datePipe.transform(data.IncidentDate, "yyyy-MM-dd HH:mm:ss");
  }

  CloseNotification(){
    // this.openedprimarykeyid = 0;
    // this.openedincid = 0;
    // this.infodata = [];

    this.openedchkid = 0;
  }

  // DismissNotification(){    
  //   var data = {
  //     chk: 0,
  //     chkid: Number(this.openedchkid),
  //     transferid: Number(this.openedtransferid),
  //     dismissby: this.userid,      
  //     clientId: this.clientid
  //   };
    
  //   this.headerService.DismissIncident(data)
  //     .pipe(first())
  //     .subscribe(result => {
  //       if (result.IsSuccess) {
  //         // this.openedprimarykeyid = 0;
  //         // this.openedincid = 0;
  //         // this.infodata = [];
  //         this.GetIncidentDataNotificationAlertPanel();
  //       }
  //       else
  //       {
  //         this.notifyService.showWarning(result.Message, 'Warning');          
  //       }
  //   });
  // }

  DetailNotification() {
    if (this.isDetailPush == false) {       
      this.isDetailPush = true;
      this.btnText = 'Summary';
    } 
    else {
      this.isDetailPush = false;
      this.btnText = 'Detail';
    }    
  }

  NavigateToPage () {
    if (this.openedchkid = 1) {      
      let returnUrl = 'master/Vehicletransfer';
      window.open(returnUrl,"_blank");
    }
    else if (this.openedchkid = 2) {
      let returnUrl = 'master/StaffTransfer';
      window.open(returnUrl,"_blank");
    }
  }
  ///// End - Push Notification Dialog

}
